/*@flow*/
export default function deleteKeys(
  o: Object,
  predicate: (k: string) => boolean
): Object {
  Object.keys(o).forEach(k => {
    if (predicate(k)) {
      delete o[k];
    }
  });
  return o;
}
